import { useCallback, useEffect, useState } from 'react';

export function useHashRouting(defaultRoute?: string) {
  const [currentHash, setCurrentHash] = useState(() => window.location.hash);

  useEffect(() => {
    const onHashChange = () => {
      setCurrentHash(window.location.hash);
    };

    if (!currentHash && defaultRoute) {
      window.location.hash = defaultRoute;
    }

    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const isActive = (hash?: string) => {
    return hash ? currentHash === `#${hash}` : Boolean(currentHash);
  };

  const setActive = useCallback((hash: string) => {
    window.location.hash = hash;
  }, []);

  return { isActive, setActive, currentHash: currentHash.replace('#', '') };
}
